"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.APFormSubmit = void 0;
var Button_1 = __importDefault(require("@material-ui/core/Button"));
var CircularProgress_1 = __importDefault(require("@material-ui/core/CircularProgress"));
var react_1 = __importStar(require("react"));
var APForm_1 = require("../forms/APForm");
function APFormSubmit(_a) {
    var onClick = _a.onClick, children = _a.children, _b = _a.color, color = _b === void 0 ? "primary" : _b, _c = _a.variant, variant = _c === void 0 ? "contained" : _c, nonSubmit = _a.nonSubmit, _d = _a.size, size = _d === void 0 ? 'large' : _d, style = _a.style;
    var _e = react_1.useState(false), disabled = _e[0], setDisabled = _e[1];
    function onclick() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!disabled) return [3 /*break*/, 3];
                        setDisabled(true);
                        if (!onClick) return [3 /*break*/, 2];
                        return [4 /*yield*/, onClick()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        setDisabled(false);
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    var control2 = react_1.useContext(APForm_1.APFormContext);
    if (nonSubmit)
        control2 = undefined;
    if (control2 !== undefined) {
        control2.submit = onclick;
    }
    var disabled2 = disabled;
    if (!onClick) {
        disabled2 = true;
    }
    return (react_1.default.createElement(Button_1.default, { size: size, style: __assign({ paddingLeft: 8, paddingRight: 8, marginTop: 16 }, style), disabled: disabled2, variant: variant, color: color, onClick: control2 ? undefined : onclick, type: nonSubmit ? undefined : 'submit' },
        disabled && react_1.default.createElement(CircularProgress_1.default, { size: 12, thickness: 6, style: { marginRight: 6 }, color: "inherit" }),
        children));
}
exports.APFormSubmit = APFormSubmit;
